import { defineMessages } from "@ai360/core/intl";
export const messages = defineMessages({
    applicationEquationFormLabelText: {
        id: "recModule.recInfo.applicationEquationFormLabelText",
        defaultMessage: "Equation",
    },
    missingTestResultsText: {
        id: "recModule.recInfo.missingTestResultsText",
        defaultMessage: "Missing Test Results For ",
    },
    parametersText: {
        id: "recModule.recInfo.parametersText",
        defaultMessage: "Parameters",
    },
    nutrientsText: {
        id: "recModule.recInfo.nutrientsText",
        defaultMessage: "Nutrients & Products",
    },
    cropText: {
        id: "recModule.recInfo.cropText",
        defaultMessage: "Crop",
    },
    cropClassText: {
        id: "recModule.recInfo.cropClassText",
        defaultMessage: "Crop Class",
    },
    cropPurposeText: {
        id: "recModule.recInfo.cropPurposeText",
        defaultMessage: "Crop Purpose",
    },
    previousCropText: {
        id: "recModule.recInfo.previousCropText",
        defaultMessage: "Previous Crop",
    },
    nextCropText: {
        id: "recModule.recInfo.nextCropText",
        defaultMessage: "Next Crop",
    },
    soilTextureText: {
        id: "recModule.recInfo.soilTextureText",
        defaultMessage: "Soil Texture",
    },
    tillageMethodText: {
        id: "recModule.recInfo.tillageMethodText",
        defaultMessage: "Tillage Method",
    },
    applicationTimingText: {
        id: "recModule.recInfo.applicationTimingText",
        defaultMessage: "Application Timing",
    },
    applicationMethodText: {
        id: "recModule.recInfo.applicationMethodText",
        defaultMessage: "Application Method",
    },
    processingText: {
        id: "recModule.recInfo.processingText",
        defaultMessage: "Processing",
    },
    productText: {
        id: "recModule.recInfo.productText",
        defaultMessage: "Product",
    },
    incorporationDepthText: {
        id: "recModule.recInfo.incorporationDepthText",
        defaultMessage: "Incorporation Depth",
    },
    buildFactorText: {
        id: "recModule.recInfo.buildFactorText",
        defaultMessage: "Build Factor",
    },
    targetpHText: {
        id: "recModule.recInfo.targetpHText",
        defaultMessage: "Target pH",
    },
    recOptionText: {
        id: "recModule.recInfo.recOptionText",
        defaultMessage: "Rec Option",
    },
    samplingDepthText: {
        id: "recModule.recInfo.samplingDepthText",
        defaultMessage: "Sampling Depth",
    },
    setDefaultText: {
        id: "recModule.recInfo.setDefaultText",
        defaultMessage: "Set Default",
    },
    setProductText: {
        id: "recModule.recInfo.setProductText",
        defaultMessage: "Set Product",
    },
    managementAreaText: {
        id: "recModule.recInfo.managementAreaText",
        defaultMessage: "Management Area",
    },
    normalizedYieldText: {
        id: "recModule.recInfo.normalizedYieldText",
        defaultMessage: "Normalized Yield",
    },
    batchEditRecsModalTitleText: {
        id: "recModule.recInfo.batchEditRecsModalTitleText",
        defaultMessage: "Batch Edit Recs",
    },
    sameEquationSetRequiredText: {
        id: "recModule.recInfo.sameEquationSetRequiredText",
        defaultMessage: "All Recs selected must have the same Equation Set",
    },
    unknownEquationText: {
        id: "recModule.recInfo.unknownEquationText",
        defaultMessage: "Unknown Equation",
    },
    unknownEquationSetText: {
        id: "recModule.recInfo.unknownEquationSetText",
        defaultMessage: "an unknown equation set",
    },
    isUsingText: {
        id: "recModule.recInfo.isUsingText",
        defaultMessage: " is using ",
    },
    unmatchingRecsText: {
        id: "recModule.recInfo.unmatchingRecsText",
        defaultMessage: "Unmatching Rec(s): ",
    },
});
